<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17lkewW/media/FC-9781398426283.jpg?1692049823953" alt="This image is the cover for the book Rivertown"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rivertown
      </h1>
      <p class="bookDescription body article font2">
        <p>The tragic accidental drowning of Thomas’ younger brother results in the decimation of his family. Thomas’ father, unable to deal with the loss, turns to violence and alcohol, and his mother, as an attempt to extricate herself from the abuse, makes a failed attempt to kill his father, sending her to prison. Thomas spends the rest of his life attempting to assuage his guilt, as he blames himself for the death of his brother. He seeks peace initially through life in a monastery, subsequently moving to London where he meets Iris, through whom he achieves a partial healing. The story of Rivertown reflects the meaningful contrast between hardship and prosperity in which the outcome of relative coexistence within such differences may result in an appreciation of natural truth and virtue.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Larry McEvoy
      </h2>
      
      <p class="authorDescription body article">The author grew up in South Dublin. He subsequently obtained three university degrees; at University College Dublin (BA Social Science), University of Surrey (MSC Applied Social Studies), University of London (BA Philosophy). After working in banking, on building sites and with alcoholics, he spent the majority of his career in the Probation Service in London, including two spells working in London prisons. Since retiring he has been writing poetry and short stories. This is his first novel. He enjoys running and is still competing in half marathons. He lives in Buckinghamshire with his wife and has two adult children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7dc97764